import React, { useEffect, useState, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import moment from "moment";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import {
  getReportTemplateParameter,
  createNewReport,
  getUpdatedCustomerReportData,
  updateReport,
  resetBookingData,
  updateNiptDob,
  createNiptDob,
  getNiptGraphData
} from "../../../actions/LimsAdminActions";
import logo from "../../../../redcliffe_logo.jpeg";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import { useNavigate } from 'react-router-dom';
import qcCode from "../../qrcode.png";
import testLogo from "./Asset 2.png";
import pregnantImg from "./pregnent.png";
import c1 from "../Nipt/Image/P_CHROMOSOME 1.png"
import c2 from "../Nipt/Image/P_CHROMOSOME 2.png"
import c3 from "../Nipt/Image/P_CHROMOSOME 3.png"
import c4 from "../Nipt/Image/P_CHROMOSOME 4.png"
import c5 from "../Nipt/Image/P_CHROMOSOME 5.png"
import c6 from "../Nipt/Image/P_CHROMOSOME 6.png"
import c7 from "../Nipt/Image/P_CHROMOSOME 7.png"
import c8 from "../Nipt/Image/P_CHROMOSOME 8.png"
import c9 from "../Nipt/Image/P_CHROMOSOME 9.png"
import c10 from "../Nipt/Image/P_CHROMOSOME 10.png"
import c11 from "../Nipt/Image/P_CHROMOSOME 11.png"
import c12 from "../Nipt/Image/P_CHROMOSOME 12.png"
import c14 from "../Nipt/Image/P_CHROMOSOME 14.png"
import c15 from "../Nipt/Image/P_CHROMOSOME 15.png"
import c16 from "../Nipt/Image/P_CHROMOSOME 16.png"
import c17 from "../Nipt/Image/P_CHROMOSOME 17.png"
import c19 from "../Nipt/Image/P_CHROMOSOME 19.png"
import c20 from "../Nipt/Image/P_CHROMOSOME 20.png"
import c22 from "../Nipt/Image/P_CHROMOSOME 22.png"
import c21 from "../Nipt/Image/Chromosome 21.png"
import c18 from "../Nipt/Image/Chromosome 18.png"
import c13 from "../Nipt/Image/Chromosome 13.png"

import QRCode from "react-qr-code";
import iso from "../../iso.png";
import browserIcon from "../../../../browsericon.png";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import { Select, MenuItem, TextField } from '@material-ui/core';
import "./report1.css";
import { ClassNames } from "@emotion/react";
import { textAlign, width } from "@mui/system";
import Loader from "../../../components/loader/index";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
import { Collections } from "@material-ui/icons";
import NpsRating from "../../NPS/index";
import ChromosomeGraphs from "./ChromosomeGraphs";

const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      width: "100%",
    },
    centerIt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    fontWeight: {
      fontWeight: "bold",
    },
    textCenter: {
      textAlign: "center",
    },
    endIt: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    belowIt: {
      display: "flex",
      alignItems: "flex-end",
    },
    line: {
      borderBottom: "5px solid red",
      marginTop: "5px",
      width: "90%",
    },
    textarea: {
      resize: "none",
    },
    tableBody: {
      maxHeight: 60,
      overflowY: "auto",
    },
    input: {
      padding: "1px",
    },
    tableCell: {
      padding: 2,
      height: 10,
    },
    select: {
      "&:before": {
        display: "none", // Hide the arrow icon
      },
      "&:after": {
        display: "none", // Hide the arrow icon
      },
    },
  })
);

interface Props {
  reportListParameter: any;
  getReportTemplateParameter: any;
  bookingId: any;
  reportData: any;
  createNewReport: any;
  getUpdatedCustomerReportData: any;
  updateReport: any;
  resetBookingData: any;
  updateNiptDob: any;
  createNiptDob: any;
  createcollectiondate: any;
  updatecreatecollectiondate: any;
  loading: boolean;
  getNiptGraphData:any;
  niptGraphData:any;

}
const NIPTReport: React.FC<Props> = ({
  getReportTemplateParameter,
  reportListParameter,
  bookingId,
  reportData,
  createNewReport,
  getUpdatedCustomerReportData,
  updateReport,
  resetBookingData,
  updateNiptDob,
  createNiptDob,
  createcollectiondate,
  updatecreatecollectiondate,
  loading,
  getNiptGraphData,
  niptGraphData

}) => {
  const textareRef = useRef();
  const componentRef = useRef<any>(null);
  const { firstP, secondP, thirdP } = useParams<any>();
  const classes = useStyles();
  const navigate = useNavigate();
  const [dob, setDob] = useState<any>("");
  const [age, setAge] = useState<any>("");
  const [Sample_Received, setSample_Received] = useState<any>("");
  const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
  const [Sample_Collected, setSample_Collected] = useState<any>("");
  const [designation, setdesignation] = useState<any>("");
  const [Name, setName] = useState<any>("");

  const [Gender, setGender] = useState<any>("");
  const [uuid, setUuid] = useState()

  // const [Sample_Collected, setSample_Collected] = useState<any>("");

  const [status, setStatus] = useState<string>(reportListParameter?.status);
  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);


  const reactToPrintTrigger = React.useCallback(() => {
    return (
      <button
        style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
      >
        Print Report
      </button>
    );
  }, []);

  //booking data
  const [niptReport, setNiptReport] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.booking &&
      reportListParameter?.booking.length > 0
    ) {
      reportListParameter?.booking?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setNiptReport(data);
  }, [reportListParameter]);


  useEffect(() => {
    setSample_Collected(niptReport[0]?.collection_date);
    setSample_Receivedtime(niptReport[0]?.pickup_time?.split('.')[0]);
    setdesignation(niptReport[0]?.designation);
    setGender(niptReport[0]?.customer_gender);
    setSample_Received(niptReport[0]?.pickup_date);

    setName(niptReport[0]?.customer_name);
    setUuid(niptReport[0]?.uuid)
  }, [niptReport]);



  // {niptReport[0]?.designation}&nbsp;{niptReport[0]?.customer_name}

  //clinical_comments
  const [niptComment, setNiptComment] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.clinical_comments &&
      reportListParameter?.clinical_comments.length > 0
    ) {
      reportListParameter?.clinical_comments?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setNiptComment(data);
  }, [reportListParameter]);

  const updateComments = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...niptComment];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setNiptComment(storeData);
  };
  //about this results
  const [niptAbout, setNiptAbout] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.about_nipt &&
      reportListParameter?.about_nipt.length > 0
    ) {
      reportListParameter?.about_nipt?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setNiptAbout(data);
  }, [reportListParameter]);

  const updateAboutData = (
    id: number,
    value: any,
    index: number,
    key: string,
    object: any
  ) => {
    let storeData = [...niptAbout];
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setNiptAbout(storeData);
  };

  //disclaimer
  const [niptdisclamer, setNiptdisclaimer] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.disclaimer &&
      reportListParameter?.disclaimer.length > 0
    ) {
      reportListParameter?.disclaimer?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setNiptdisclaimer(data);
  }, [reportListParameter]);



  //doctor list
  const [niptdoctorList, setNiptdoctorList] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.doctor_list &&
      reportListParameter?.doctor_list.length > 0
    ) {
      reportListParameter?.doctor_list?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setNiptdoctorList(data);
  }, [reportListParameter]);

  const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...niptdoctorList]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setNiptdoctorList(storeData);
  }


  const [niptMethology, setNiptMethology] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.methodology &&
      reportListParameter?.methodology.length > 0
    ) {
      reportListParameter?.methodology?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setNiptMethology(data);
  }, [reportListParameter]);

  const updateMethology = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...niptMethology]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setNiptMethology(storeData);
  }

  const [niptExpectedResult, setNiptExpectedResults] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.Expected_Test_Result &&
      reportListParameter?.Expected_Test_Result.length > 0
    ) {
      reportListParameter?.Expected_Test_Result?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setNiptExpectedResults(data);
  }, [reportListParameter]);

  const updateExpectedResults = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...niptExpectedResult]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setNiptExpectedResults(storeData);
  }

  // gestation age 
  const [gestation, setGestation] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.gestation_age &&
      reportListParameter?.gestation_age.length > 0
    ) {
      reportListParameter?.gestation_age?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setGestation(data);
  }, [reportListParameter]);

  const updateGestationValue = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...gestation]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setGestation(storeData);
  }

  //reason for testing
  const [resonfor, setResonFor] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.reason_for_testing &&
      reportListParameter?.reason_for_testing.length > 0
    ) {
      reportListParameter?.reason_for_testing?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setResonFor(data);
  }, [reportListParameter]);

  const updateItemValue = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...resonfor]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setResonFor(storeData);
  }

  //pregnancyType
  const [pregnancy, setPregnancy] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.pregnancyType &&
      reportListParameter?.pregnancyType.length > 0
    ) {
      reportListParameter?.pregnancyType?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setPregnancy(data);
  }, [reportListParameter]);

  const updatePregnancyType = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...pregnancy]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setPregnancy(storeData);
  }
  //clinical name
  const [clinicalName, setClinicalName] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.clinical_name &&
      reportListParameter?.clinical_name.length > 0
    ) {
      reportListParameter?.clinical_name?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setClinicalName(data);
  }, [reportListParameter]);

  const updateClinicalName = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...clinicalName]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setClinicalName(storeData);
  }

  //hospital name
  const [hospitalName, setHospitalName] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.hospital_name &&
      reportListParameter?.hospital_name.length > 0
    ) {
      reportListParameter?.hospital_name?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setHospitalName(data);
  }, [reportListParameter]);

  const updateHospitalName = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...hospitalName]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setHospitalName(storeData);
  }

  //Fetal Results
  const [fetalData, setFetalData] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.fetal &&
      reportListParameter?.fetal.length > 0
    ) {
      reportListParameter?.fetal?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setFetalData(data);
  }, [reportListParameter]);

  const updateFetalData = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...fetalData]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setFetalData(storeData);
  }

  //Hospital ID
  // Hospital Id

  const [HospitalId, setHospitalId] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.Hospital_Id
      &&
      reportListParameter?.Hospital_Id

        .length > 0
    ) {
      reportListParameter?.Hospital_Id

        ?.map((list: any) => {
          data?.push({ ...list });
        });
    }
    setHospitalId(data);
  }, [reportListParameter]);

  const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...HospitalId]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setHospitalId(storeData);
  }


  // const updateFetalData = (
  //   id: number,
  //   value: any,
  //   index: number,
  //   key: string,
  //   object: any
  // ) => {
  //   let storeData = [...fetalData];
  //   let newItem = object;
  //   switch (key) {
  //     case "free_text":
  //       newItem.parameter_value = value;
  //       break;
  //   }
  //   storeData[index] = newItem;
  //   setFetalData(storeData);
  // };

  useEffect(() => {
    if (thirdP !== "add") {
      getUpdatedCustomerReportData(
        `booking_id=${firstP}&template_id=${secondP}`
      );
    } else {
      getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
    }
  }, []);

  useEffect(() => {
    resetBookingData();
    getNiptGraphData(`?booking_id=${firstP}&count=100`);
  }, [])

  console.log(niptGraphData,"sdciosdnciosdncsdoic")


  const submitData = async (e: any) => {
    e.preventDefault();
    let storeData: any = [];

    if (resonfor.length > 0) {
      resonfor?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (gestation.length > 0) {
      gestation?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (niptAbout.length > 0) {
      niptAbout?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (HospitalId.length > 0) {
      HospitalId?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (niptComment.length > 0) {
      niptComment?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (niptMethology.length > 0) {
      niptMethology?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    if (niptExpectedResult.length > 0) {
      niptExpectedResult?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    const stringify = JSON.stringify(tableData);
    if (nipttestResult.length > 0) {
      nipttestResult?.map((list: any) => {
        storeData.push({
          ...list,
          parameter_value: stringify,
        });
      });
    }
    const stringify1 = JSON.stringify(chromosomTableData);
    if (chromosomeData.length > 0) {
      chromosomeData?.map((list: any) => {
        storeData.push({
          ...list,
          parameter_value: stringify1,
        });
      });
    }

    if (fetalData.length > 0) {
      fetalData?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (niptdoctorList.length > 0) {
      niptdoctorList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (pregnancy.length > 0) {
      pregnancy?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (clinicalName.length > 0) {
      clinicalName?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (hospitalName.length > 0) {
      hospitalName?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }

    const reportData = {
      template_id: secondP,
      booking_id: firstP,
      case_id: firstP,
      template_parameter: storeData,
      dob: dob,
      status: status,
      customer_age: age,
      collection_date: Sample_Collected,
      pickup_date: Sample_Received,
      pickup_time: Sample_Receivedtime,
      customer_gender: Gender,
      customer_name: Name,
      designation: designation,
    };
    const reportEditData = {
      template_id: secondP,
      booking_id: firstP,
      case_id: firstP,
      status: status,
      template_parameter: storeData,
      dob: dob,
      customer_age: age,
      collection_date: Sample_Collected,
      pickup_date: Sample_Received,
      pickup_time: Sample_Receivedtime,
      customer_gender: Gender,
      customer_name: Name,
      designation: designation,
    };

    if (thirdP === "add") {
      await createNewReport(reportData);
      navigate('/dashboard/la');
    } else if (thirdP === "edit") {
      await updateReport(reportListParameter?.id, reportEditData);
      if (thirdP === "edit") {
        if (dob || age || Sample_Collected || Sample_Received || Sample_Receivedtime || Gender || designation || Name || status) {
          await updateNiptDob(reportListParameter?.id, { dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status });
        } else {
          console.error("Missing dob value for updateNiptDob");
        }
      } else {
        await createNiptDob(reportListParameter?.id, {
          dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status
        });
      }
    }
  };


  useEffect(() => {
    const textarea = document.querySelector("textarea")!;
    if (textarea) {
      textarea.style.height = "5px";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }, [niptComment]);


  useEffect(() => {
    if (dob) {
      const currentDate = new Date();
      const dobDate = new Date(dob);
      const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
      const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
      setAge(ageInYears);
    } else if (niptReport[0]?.customer_age) {
      setAge(niptReport[0].customer_age);
    } else {
      setAge(0); 
    }
  }, [dob, niptReport]);
  

  let niptData = [
    {
      id: 1,
      name: "Down syndrome (Trisomy 21)",
      img: c21,
      result: "Low Risk:Result consistent with two copies of chromosome 21 ",
      score: 99.9,
      risk: "green",
    },
    {
      id: 2,
      name: "Edwards syndrome (Trisomy 18)",
      img: c18,
      result: "Low Risk:Result consistent with two copies of chromosome 18 ",
      score: 99.9,
      risk: "green",
    },
    {
      id: 3,
      name: "Patau syndrome (Trisomy 13)",
      img: c13,
      result: "Low Risk:Result consistent with two copies of chromosome 13 ",
      score: 99.9,
      risk: "green",
    },
    {
      id: 4,
      name: "Sex Chromosomes",
      result: "Low Risk",
      score: 99.9,
      risk: "green",
    },
  ];
  const [nipttestResult, setNiptResult] = useState([]);

  useEffect(() => {
    let storeData: any = [];
    if (
      reportListParameter &&
      reportListParameter?.test_result_nipt &&
      reportListParameter?.test_result_nipt.length > 0
    ) {
      reportListParameter?.test_result_nipt?.map((list: any) => {
        storeData.push({ ...list });
      });
    }
    setNiptResult(storeData);
  }, [reportListParameter]);

  const [tableData, setTableData] = useState<any>([]);

  useEffect(() => {
    let data: any,
      parse: any,
      storeData: any = [];
    if (
      reportListParameter &&
      reportListParameter?.test_result_nipt &&
      reportListParameter?.test_result_nipt.length > 0
    ) {
      data = reportListParameter?.test_result_nipt[0]?.parameter_value;
      if (data) {
        parse = JSON.parse(data);
      }
      if (parse?.length > 0) {
        parse?.map((list: any) => {
          storeData.push({
            ...list,
          });
        });
      } else {
        niptData?.map((list: any) => {
          storeData.push({
            ...list,
          });
        });
      }
    }
    setTableData(storeData);

  }, [reportListParameter]);
  const updateRow = (index: number, key: string, value: any, object: any) => {
    let storeData = [...tableData];
    // let newItem = object;
    let newItem = storeData[index];
    switch (key) {
      case "name":
        newItem.name = value;
        break;
      case "img":
        newItem.name = value || "";
        break;
      case "result":
        newItem.result = value;
        break;
      case "risk":
        newItem.risk = value;
        break;
      case "score":
        newItem.score = value;
        break;
    }
    storeData[index] = newItem;
    setTableData(storeData);
  };

  let chromoData = [
    {
      id: 1,
      name: "CHROMOSOME 1",
      img: c1,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 2,
      name: "CHROMOSOME 2",
      img: c2,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 3,
      name: "CHROMOSOME 3",
      img: c3,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 4,
      name: "CHROMOSOME 4",
      img: c4,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 5,
      name: "CHROMOSOME 5",
      img: c5,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 6,
      name: "CHROMOSOME 6",
      img: c6,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 7,
      name: "CHROMOSOME 7",
      img: c7,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 8,
      name: "CHROMOSOME 8",
      img: c8,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 9,
      name: "CHROMOSOME 9",
      img: c9,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 10,
      name: "CHROMOSOME 10",
      img: c10,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 11,
      name: "CHROMOSOME 11",
      img: c11,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 12,
      name: "CHROMOSOME 12",
      img: c12,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 13,
      name: "CHROMOSOME 14",
      img: c14,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 14,
      name: "CHROMOSOME 15",
      img: c15,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 14,
      name: "CHROMOSOME 16",
      img: c16,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 14,
      name: "CHROMOSOME 17",
      img: c17,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 14,
      name: "CHROMOSOME 19",
      img: c19,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 14,
      name: "CHROMOSOME 20",
      img: c20,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
    {
      id: 14,
      name: "CHROMOSOME 22",
      img: c22,
      result: "Low_Risk",
      score: 99.9,
      risk: "green",
      sensitivity: 99.9,
    },
  ];
  const [chromosomeData, setChromosomeData] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.chromosome_risk &&
      reportListParameter?.chromosome_risk.length > 0
    ) {
      reportListParameter?.chromosome_risk?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setChromosomeData(data);
  }, [reportListParameter]);

  const [chromosomTableData, setChromosomTableData] = useState<any>([])
  useEffect(() => {
    let data: any,
      parse: any,
      storeData: any = [];
    if (
      reportListParameter &&
      reportListParameter?.chromosome_risk &&
      reportListParameter?.chromosome_risk.length > 0
    ) {
      data = reportListParameter?.chromosome_risk[0]?.parameter_value;
      if (data) {
        parse = JSON.parse(data);
      }
      if (parse?.length > 0) {
        parse?.map((list: any) => {
          storeData.push({
            ...list,
          });
        });
      } else {
        chromoData?.map((list: any) => {
          storeData.push({
            ...list,
          });
        });
      }
    }
    setChromosomTableData(storeData);
  }, [reportListParameter]);

  const updateChromoData = (index: any, key: any, value: any, list: any) => {
    let storeData = [...chromosomTableData];
    // Create a deep copy of the item to avoid read-only property issues
    let newItem = JSON.parse(JSON.stringify(storeData[index]));
    switch (key) {
      case "name":
        newItem.name = value;
        break;
      case "img":
        newItem.img = value;
        break;
      case "result":
        newItem.result = value;
        break;
      case "risk":
        newItem.risk = value;
        break;
      case "score":
        newItem.score = value;
        break;
      case "sensitivity":
        newItem.sensitivity = value;
        break;
    }
    storeData[index] = newItem;
    setChromosomTableData(storeData);
  };



  console.log(chromosomTableData,"sciondiocncoidsc")


  // const handleClientdata = async (e: any) => {
  //   e.preventDefault();
  //   const clientData = {
  //     dob
  //   };
  //   const clientDataEdit = {
  //     dob
  //   };
  //   if (thirdP === "edit") {
  //     await updateNiptDob(clientDataEdit);
  //   } else {
  //     await createNiptDob(clientData);
  //   }
  // };

  const [isInputFocused, setInputFocused] = useState(false);

  const handleInputFocus = () => {
    setInputFocused(true);
  };

  const handleInputBlur = () => {
    setInputFocused(false);
  };

  const [uhid, setuhid] = useState<any>([]);
  const [tempCode, setTempCode] = useState<any>([]);
  useEffect(() => {
    setuhid(reportListParameter?.uhid)
    setTempCode(reportListParameter?.template_code)
  }, [reportListParameter])
  const documentTitle = `${niptReport[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;

  return (
    <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq" >
      <div style={{ margin: "55px auto" }}>
        <div>
          <div style={{ height: "20px" }}>
            <div>
              {thirdP !== "add" && (
                <ReactToPrint
                  content={reactToPrintContent}
                  trigger={reactToPrintTrigger}
                  documentTitle={documentTitle}
                />
              )}
            </div>
          </div>
          <div style={{ width: "200px", marginLeft: "780px" }}>
            <TextField
              id="outlined-select-currency"
              select
              variant="outlined"
              fullWidth
              className={classes.input}
              label="Select Report Type"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              style={{ height: "30px" }}
            >
              <MenuItem value={"Draft"}>Draft</MenuItem>
              <MenuItem value={"Editable"}>Editable</MenuItem>
              <MenuItem value={"Approved"}>Approved</MenuItem>
              <MenuItem value={"Hold"}>Hold</MenuItem>
              <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
            </TextField>
          </div>
          <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
            <div>
              <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
            </div>
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <div
            id="PAGE"
            ref={componentRef}
            style={{
              width: 1122,
              background: "#fff",
            }}
          >
            {/* header section */}
            <div className="page-header">
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    background: "#fff",
                  }}
                >
                  <div style={{ width: "80%", padding: 15 }}>
                    <div
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "30px",
                        textAlign: "left",
                      }}
                    >
                      LABORATORY REPORT
                    </div>
                  </div>
                  <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                    <h3>
                      <img src={logo} alt="logo" style={{ width: "200px" }} />
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            {/* header section closed */}

            {/* patient section details */}
            <div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  background: "#fff",
                  alignContent: "center",
                }}
                className="bodyPage"
              >
                <div style={{ width: "70%", padding: 15 }}>
                  <div
                  >
                  </div>
                </div>
                {gestation?.map((list: any, index: number) => {
                  return (
                    <div
                      style={{
                        width: "30%",
                        fontWeight: "bold",
                        borderRadius: "0px 10px",
                        background: "#2982ab",
                        textAlign: "center",
                        color: "white",
                        marginTop: "10px"
                      }}
                      className="bodyPage-b"
                    >
                      Gestation Age:&nbsp;<input style={{ border: "none", width: "65%", background: "none", color: "white" }} value={list?.parameter_value} onChange={(e: any) => updateGestationValue(list?.id, e.target.value, index, "free_text", list)} />
                    </div>
                  )
                })
                }
              </div>
            </div>
            <div
              style={{ padding: "20", border: "1px solid", borderRadius: "4px", }}
              className="bodyPage-a"
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  background: "#fff",

                }}
              >

              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                  fontSize: "15px"
                }}
              >
                <div style={{ width: "30%", marginLeft: 8 }}>
                  Patient Id:&nbsp;&nbsp;{niptReport[0]?.pk}
                </div>
                <div style={{ width: "30%", marginLeft: 8 }}>
                  Gender:&nbsp;&nbsp;
                  <input
                    className="input"
                    style={{ border: "none", width: "65%", textAlign: "start", appearance: "none" }}
                    type="text"
                    value={Gender}
                    onChange={(e) => setGender(e.target.value)}
                  />
                </div>
                <div style={{ width: "40%", marginLeft: 8 }}>
                  Center Code:&nbsp;&nbsp;{niptReport[0]?.center?.name}</div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                }}
              >
                <div style={{ width: "30%", marginLeft: 8 }}>
                  Patient Name:&nbsp;&nbsp;
                  <input
                    className="input"
                    style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none" }}
                    type="text"
                    value={designation}
                    onChange={(e) => setdesignation(e.target.value)}
                  />
                  <input
                    className="input"
                    style={{ border: "none", width: "50%", textAlign: "start", appearance: "none" }}
                    type="text"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                {clinicalName?.map((list: any, index: number) => {
                  return (
                    <div style={{ width: "30%", marginLeft: 8 }}>
                      Clinician Name:&nbsp;<input style={{ border: "none", width: "67%" }} value={list?.parameter_value} onChange={(e: any) => updateClinicalName(list?.id, e.target.value, index, "free_text", list)} />
                    </div>
                  )
                })
                }
                <div style={{ width: "40%", marginLeft: 8 }}>
                  Sample Collected:&nbsp;&nbsp;<input
                    className="input"
                    style={{ border: "none", width: "65%", textAlign: "start", appearance: "none" }}
                    type="text"
                    placeholder="yyyy-mm-dd"
                    pattern="\d{4}-\d{2}-\d{2}"
                    value={Sample_Collected}
                    onChange={(e) => setSample_Collected(e.target.value)}
                  />
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                }}
              >
                {niptReport[0]?.dob === null ?
                  <div style={{ width: "30%", marginLeft: 8 }}>
                    Patient DOB:&nbsp;&nbsp;<input
                      className="input"
                      style={{ border: "none", width: "65%", textAlign: "start", appearance: "none" }}
                      type="text"
                      value={dob}
                      placeholder={isInputFocused ? 'YYYY-MM-DD' : ''}
                      onChange={(e) => {
                        setDob(e.target.value);
                      }}
                      onFocus={handleInputFocus}
                      onBlur={handleInputBlur}
                    />
                  </div> :
                  <div style={{ width: "30%", marginLeft: 8 }}>
                    Patient DOB:&nbsp;&nbsp;{niptReport[0]?.dob}
                  </div>

                }
                {pregnancy?.map((list: any, index: number) => {
                  return (
                    <div style={{ width: "30%", marginLeft: 8 }}>
                      Pregnancy Type:&nbsp;<input style={{ border: "none", width: "65%" }} value={list?.parameter_value} onChange={(e: any) => updatePregnancyType(list?.id, e.target.value, index, "free_text", list)} />
                    </div>
                  )
                })
                }
                <div style={{ width: "40%", marginLeft: 8 }}>Sample Received:&nbsp;<input
                  className="input"
                  style={{ border: "none", width: "18%", textAlign: "start", appearance: "none" }}
                  type="text"
                  placeholder="yyyy-mm-dd"
                  value={Sample_Received}
                  onChange={(e) => setSample_Received(e.target.value)}
                />,
                  <input
                    className="input"
                    style={{ border: "none", width: "25%", textAlign: "start", appearance: "none" }}
                    type="text"
                    placeholder="HH:MM:SS"
                    value={Sample_Receivedtime?.split('.')[0]}
                    onChange={(e) => setSample_Receivedtime(e.target.value)}
                  />
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                }}
              >
                {niptReport[0]?.dob !== null ?
                  <div style={{ width: "30%", marginLeft: 8 }}>
                    Age:&nbsp;&nbsp;{niptReport && niptReport[0]?.customer_age}
                  </div> :
                  <div style={{ width: "30%", marginLeft: 8 }}>
                    Age:&nbsp;&nbsp;<input
                      className="input"
                      style={{ border: "none", width: "65%", textAlign: "start", appearance: "none" }}
                      type="text"
                      value={age}
                      onChange={(e) => setAge(e.target.value)}
                    />
                  </div>

                }
                {hospitalName?.map((list: any, index: number) => {
                  return (
                    <div style={{ width: "30%", marginLeft: 8 }}>
                      Hospital Name:&nbsp;<input style={{ border: "none", width: "67%" }} value={list?.parameter_value} onChange={(e: any) => updateHospitalName(list?.id, e.target.value, index, "free_text", list)} />
                    </div>
                  )
                })
                }
                <div style={{ width: "40%", marginLeft: 8 }}>Report Released:&nbsp;&nbsp;{moment.tz(Date.now(), "Asia/Kolkata").format("YYYY-MM-DD,HH:mm:ss")}</div>
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                }}
              >
                {niptReport[0]?.center?.name && niptReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                  <div style={{ width: "100%", display: "flex", }}>
                    {HospitalId?.map((list: any, index: number) => {
                      return (
                        <div style={{ width: "30%", marginLeft: 8 }}>
                          Hospital ID :
                          <input
                            key={list?.id}
                            style={{ border: "none", width: "70%", background: "none", }}
                            value={list?.parameter_value}
                            onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                          />
                        </div>
                      );
                    })}

                  </div>
                ) : null}
              </div>
            </div>
            {/* patient details section closed */}

            {/* body page */}
            <div style={{ width: "90%", marginLeft: "50px" }}>
              <h6 style={{ backgroundColor: "rgb(22 55 88)", color: "white", textAlign: "center", borderRadius: "3px", height: "25px" }}>Test Performed:-{niptReport[0]?.packages[0]?.name}</h6>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                margin: "0px 10px",
                textAlign: "start",
                borderRadius: "0px 10px",
                marginLeft: 28,
              }}
            >
              <h6>Clinical Indication:</h6>
            </div>

            {resonfor.map((list: any, index: number) => {
              return (
                <div>
                    <textarea
                      style={{ resize: "none", border: "none", marginLeft: "28px", minHeight: "70px", fontSize: "15px" }}
                      rows={3}
                      cols={140}
                      value={list?.parameter_value}
                      onChange={(e) => updateItemValue(list?.id, e.target.value, index, "free_text", list)}
                    />
                </div>
              );
            })}
            <div style={{ padding: "20" }} className="merginLeft">
              {/* results heading */}
              <div
                style={{ padding: "15", border: "1px solid", borderRadius: "4px", }}
              >
                <div style={{ fontWeight: "bold", fontSize: "20px", color: "white", height: "40px" }} className="box">
                  <img
                    src={testLogo}
                    alt="logo"
                    style={{ width: "20px", margin: "2px" }}
                  />
                  &nbsp;&nbsp;TEST RESULTS &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                  &emsp;&emsp;
                  *Fetal fraction:
                  {fetalData?.map((list: any, index: number) => {
                    return (
                      <GrammarlyEditorPlugin>
                        <input
                          style={{ border: "none", background: "none", color: "white", fontWeight: "bold" }}
                          value={list?.parameter_value}
                          onChange={(e) => updateFetalData(list?.id, e.target.value, index, "free_text", list)}
                        />
                      </GrammarlyEditorPlugin>
                    );
                  })}
                </div>
                <div style={{ border: "1px solid", width: "97%", marginLeft: "19px", marginTop: "8px", }}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      margin: "10px 0px",
                      textAlign: "start",
                      backgroundColor: "rgb(22 55 88)",
                      color: "#fff",
                      height: "25px",
                      marginTop: "-2px"
                    }}
                  >
                    <div style={{ width: "40%", marginLeft: 22, textAlign: "left", marginTop: "2px" }}>ANEUPLOIDIES</div>
                    <div style={{ width: "12%", marginLeft: 8, textAlign: "left" }}>
                    </div>
                    <div style={{ width: "25%", textAlign: "left", marginTop: "2px" }}>
                      RESULTS
                    </div>
                    <div style={{ width: "13%", marginLeft: 8, textAlign: "left", marginTop: "2px" }}>
                      Z-Score
                    </div>
                    <div style={{ width: "8%", textAlign: "center", marginTop: "2px" }}>Risk</div>
                  </div>

                  {tableData?.length > 0 &&
                    tableData?.map((list: any, index: number) => {
                      return (
                        <>
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              margin: "10px 0px",
                              textAlign: "start",
                              fontSize: "14px"
                            }}
                          >
                            <div style={{ width: "23%", marginLeft: 8 }}>
                              <GrammarlyEditorPlugin>
                                <input
                                  style={{ border: "none", width: "100%" }}
                                  value={list?.name}
                                  onChange={(e: any) =>
                                    updateRow(index, "name", e.target.value, list)
                                  }
                                />
                              </GrammarlyEditorPlugin>
                            </div>
                            <div style={list?.img ? { width: "15%", marginLeft: 8, visibility: "visible" } : { width: "15%", marginLeft: 8, visibility: "hidden" }}>
                              <img
                                src={list?.img}
                                style={{ width: "100px", margin: "2px", height: "30px", border: "none" }}
                              />
                            </div>
                            {list?.risk !== "green" ?
                              <div
                                style={{ width: "45%", marginLeft: 8, textAlign: "left" }}
                              >
                                <GrammarlyEditorPlugin>
                                  <input
                                    style={{ border: "none", width: "100%", fontWeight: "bold", color: "red" }}
                                    value={list?.result}
                                    onChange={(e: any) =>
                                      updateRow(index, "result", e.target.value, list)
                                    }
                                  />
                                </GrammarlyEditorPlugin>
                              </div> :
                              <div
                                style={{ width: "45%", marginLeft: 8, textAlign: "left" }}
                              >
                                <GrammarlyEditorPlugin>
                                  <input
                                    style={{ border: "none", width: "100%" }}
                                    value={list?.result}
                                    onChange={(e: any) =>
                                      updateRow(index, "result", e.target.value, list)
                                    }
                                  />
                                </GrammarlyEditorPlugin>
                              </div>}
                            <div
                              style={{ width: "12%", marginLeft: 8, textAlign: "left" }}
                            >
                              <GrammarlyEditorPlugin>
                                <input
                                  style={{ border: "none" }}
                                  value={list?.score}
                                  onChange={(e: any) =>
                                    updateRow(index, "score", e.target.value, list)
                                  }
                                />
                              </GrammarlyEditorPlugin>
                            </div>
                            <div
                              style={{
                                width: "8%",
                                marginLeft: 8,
                                textAlign: "center",
                              }}
                            >
                              <Select
                                style={{
                                  border: "none",
                                  outline: "none",
                                  appearance: "none",
                                }}
                                className={classes.select}
                                value={list?.risk}
                                onChange={(e: any) =>
                                  updateRow(index, "risk", e.target.value, list)
                                }
                              >
                                <MenuItem value="green">
                                  <span style={{ fontSize: "30px", color: "green" }}>
                                    &#x25CF;
                                  </span>
                                </MenuItem>
                                <MenuItem value="yellow">
                                  <span style={{ fontSize: "30px", color: "#edbe2f" }}>
                                    &#x25CF;
                                  </span>
                                </MenuItem>
                                <MenuItem value="red">
                                  <span style={{ fontSize: "30px", color: "red" }}>
                                    &#x25CF;
                                  </span>
                                </MenuItem>
                              </Select>
                            </div>
                            <div></div>
                          </div>
                        </>
                      );
                    })}
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    margin: "0px 10px",
                    textAlign: "start",
                    borderRadius: "0px 10px",
                    marginTop: "6px"
                  }}
                >
                  <h6>About this test:</h6>
                </div>

                {niptAbout.map((list: any, index: number) => {
                  return (
                    <div style={{ width: "100%", padding: 15, textAlign: "left", fontSize: "14px", marginTop: "-15px" }}>
                      <GrammarlyEditorPlugin>
                        <textarea
                          style={{ border: "none", resize: "none" }}
                          rows={3}
                          cols={145}
                          value={list?.parameter_value}
                          onChange={(e) => updateAboutData(list?.id, e.target.value, index, "free_text", list)}
                        />
                      </GrammarlyEditorPlugin>
                    </div>
                  );
                })}
              </div>
              {/* results closed*/}

              <div style={{ width: "100%", display: "flex", textAlign: "start", fontSize: "15px", marginTop: "5px" }}>
                <p>
                  *If the fetal fraction is lower than 3.5%, the accuracy of the
                  test may be reduced. To ensure the accuracy of the results, we
                  would recommend a re-sampling of the maternal blood one or two
                  weeks later.
                </p>
              </div>

              {/* Clinical Comments */}

              <div style={{ padding: "20" }}>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "20px",
                    borderRadius: "0px 10px",
                    textAlign: "left",
                    color: "#18556e",
                    marginTop:"-10px"

                  }}
                >
                  CLINICAL COMMENTS
                  <hr style={{ marginTop: "-5px", marginRight: "9px" }} />
                </div>
                {niptComment?.map((list: any, index: number) => {
                  return (
                    <div style={{ width: "100%", fontSize: "15px" }}>
                      <GrammarlyEditorPlugin>
                        <textarea
                          cols={145}
                          rows={3}
                          style={{ border: "none", resize: "none" }}
                          value={list?.parameter_value}
                          onChange={(e) =>
                            updateComments(
                              list?.id,
                              e.target.value,
                              index,
                              "free_text",
                              list
                            )
                          }
                        />
                      </GrammarlyEditorPlugin>
                    </div>
                  );
                })}
              </div>

              {/* EXPECTED TEST RESULTS */}
              <div style={{ padding: "20" }}>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "20px",
                    borderRadius: "0px 10px",
                    textAlign: "left",
                    color: "#18556e",
                    marginTop:"-7px"
                  }}
                >
                  EXPECTED TEST RESULTS
                  <hr style={{ marginTop: "-3px", marginRight: "9px" }} />
                </div>
                {niptExpectedResult?.map((list: any, index: number) => {
                  return (
                    <div style={{ width: "100%" }}>
                      <p>
                        <GrammarlyEditorPlugin>
                          <textarea
                            style={{ border: "none", resize: "none", fontSize: "15px" }}
                            rows={7}
                            cols={142}
                            value={list?.parameter_value}
                            onChange={(e) =>
                              updateExpectedResults(
                                list?.id,
                                e.target.value,
                                index,
                                "free_text",
                                list
                              )
                            }
                          />
                        </GrammarlyEditorPlugin>
                      </p>
                    </div>
                  );
                })}
              </div>
              <div
                style={{
                  width: "95%",
                  display: "flex",
                  alignItems: "center",
                  padding: 0,
                  margin: 0,
                  justifyContent: "space-around",
                  marginTop: "-20px",
                }}
              >
                {niptdoctorList &&
                  niptdoctorList?.length > 0 &&
                  niptdoctorList?.map((list: any, index: number) => {
                      const doctorLabel = String(list?.parameter_value || "").toLowerCase();
                      const isDrAnkurSignature = doctorLabel.includes("ankur") && doctorLabel.includes("jindal");
                      const hasMD115A = niptReport[0]?.packages?.some((pkg: any) => String(pkg?.code || "").trim().toUpperCase() === "MD115A");

                      if (isDrAnkurSignature && !hasMD115A) {
                        return null;
                      }

                    return (
                      <>
                        <img
                          alt="description of image"
                          style={{
                            width: "100px",
                            height: "60px",
                            marginLeft: "60px",
                          }}
                          src={list?.parameter_url}
                        />
                      </>
                    );
                  })}
              </div>
              <div
                style={{
                  width: "98%",
                  display: "flex",
                  padding: 0,
                  margin: 0,
                  justifyContent: "space-around",
                  marginLeft: "12px",
                }}
              >
                {niptdoctorList &&
                  niptdoctorList?.length > 0 &&
                  niptdoctorList?.map((list: any, index: number) => {
                      const doctorLabel = String(list?.parameter_value || "").toLowerCase();
                      const isDrAnkurSignature = doctorLabel.includes("ankur") && doctorLabel.includes("jindal");
                      const hasMD115A = niptReport[0]?.packages?.some((pkg: any) => String(pkg?.code || "").trim().toUpperCase() === "MD115A");

                      if (isDrAnkurSignature && !hasMD115A) {
                        return null;
                      }

                    return (
                      <>
                        <textarea
                          style={{
                            border: "none",
                            resize: "none",
                            textAlign: "center",
                          }}
                          rows={4}
                          cols={130}
                          value={list?.parameter_value}
                          onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                        />
                      </>
                    );
                  })}
              </div>
            </div>
            {/* body page  closed*/}

            {/* page2 */}

            {/* CHROMOSOME */}
            <div style={{ padding: "20" }} className="merginLeft tablecontent1">
              <div>.</div>
              <div style={{ padding: "20" }} className="merginLeft tablecontent5">
                <div>.</div>
              </div> 
              <div
                style={{ width: "100%", textAlign: "left" }}
                className="tablecontent2"
              >
                <div className="marginleft-b" style={{background: "#f2f4f7",borderRadius: "0px 10px",width: "710px",fontWeight: "bold"}}>
                Patient Name:&nbsp;&nbsp;{niptReport[0]?.designation}&nbsp;{niptReport[0]?.customer_name}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                Patient Id:&nbsp;&nbsp;{niptReport[0]?.pk}
                </div>
                <h5 style={{ color: "#18556e",marginTop:"5px" }}>
                  PRENATAL CHROMOSOMAL ANEUPLOIDY RESULTS FOR OTHER CHROMOSOMES
                </h5>
                <hr />
                <TableContainer style={{ borderRadius: "5px", marginTop: "3px" }}>
                  <Table stickyHeader aria-label="simple">
                    <TableHead
                      style={{ backgroundColor: "#b3b3b3", maxHeight: "4px" }}
                    >
                      <TableRow>
                        <TableCell
                          align="left"
                          style={{
                            backgroundColor: "#2982ab",
                            color: "#fff",
                          }}
                        >
                          CHROMOSOME
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            backgroundColor: "#2982ab",
                            color: "#fff",
                          }}
                        ></TableCell>
                        <TableCell
                          align="center"
                          style={{
                            backgroundColor: "#2982ab",
                            color: "#fff",
                          }}
                        >
                          RISK
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            backgroundColor: "#2982ab",
                            color: "#fff",
                          }}
                        >
                          Test Results
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            backgroundColor: "#2982ab",
                            color: "#fff",
                          }}
                        >
                          Z-SCORE
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            backgroundColor: "#2982ab",
                            color: "#fff",
                          }}
                        >
                          Sensitivity(%)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {chromosomTableData?.length > 0 &&
                      chromosomTableData?.map((list: any, index: number) => {
                        return (
                          <>
                            <TableBody className={classes.tableBody}>
                              <TableCell className={classes.tableCell} align="left">
                                <GrammarlyEditorPlugin>
                                  <input
                                    style={{ border: "none", textAlign: "center" }}
                                    value={list?.name}
                                    onChange={(e: any) =>
                                      updateChromoData(
                                        index,
                                        "name",
                                        e.target.value,
                                        list
                                      )
                                    }
                                  />
                                </GrammarlyEditorPlugin>
                              </TableCell>
                              <TableCell className={classes.tableCell} align="left">
                                <img
                                  src={list?.img}
                                  alt="logo"
                                  style={{ width: "100px", margin: "2px", height: "30px" }}
                                />
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                align="center"
                              >
                                <Select
                                  style={{
                                    border: "none",
                                    outline: "none",
                                    appearance: "none",
                                  }}
                                  className={classes.select}
                                  value={list?.risk}
                                  onChange={(e: any) =>
                                    updateChromoData(
                                      index,
                                      "risk",
                                      e.target.value,
                                      list
                                    )
                                  }
                                >
                                  <MenuItem value="green">
                                    <span
                                      style={{ fontSize: "30px", color: "green" }}
                                    >
                                      &#x25CF;
                                    </span>
                                  </MenuItem>
                                  <MenuItem value="yellow">
                                    <span
                                      style={{ fontSize: "30px", color: "#edbe2f" }}
                                    >
                                      &#x25CF;
                                    </span>
                                  </MenuItem>
                                  <MenuItem value="red">
                                    <span
                                      style={{ fontSize: "30px", color: "red" }}
                                    >
                                      &#x25CF;
                                    </span>
                                  </MenuItem>
                                </Select>
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                align="center"
                              >
                                <Select
                                  style={{
                                    border: "none",
                                    outline: "none",
                                    appearance: "none",
                                  }}
                                  className={classes.select}
                                  value={list?.result}
                                  onChange={(e: any) =>
                                    updateChromoData(
                                      index,
                                      "result",
                                      e.target.value,
                                      list
                                    )
                                  }
                                >
                                  <MenuItem value="Low_Risk">Low Risk</MenuItem>
                                  <MenuItem value="High_Risk">High Risk</MenuItem>
                                  <MenuItem value="Inconclusive">
                                    Inconclusive
                                  </MenuItem>
                                </Select>
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                align="center"
                              >
                                <GrammarlyEditorPlugin>
                                  <input
                                    style={{ border: "none", textAlign: "center" }}
                                    value={list?.score}
                                    onChange={(e: any) =>
                                      updateChromoData(
                                        index,
                                        "score",
                                        e.target.value,
                                        list
                                      )
                                    }
                                  />
                                </GrammarlyEditorPlugin>
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                align="center"
                              >
                                <GrammarlyEditorPlugin>
                                  <input
                                    style={{ border: "none", textAlign: "center" }}
                                    value={list?.sensitivity}
                                    onChange={(e: any) =>
                                      updateChromoData(
                                        index,
                                        "sensitivity",
                                        e.target.value,
                                        list
                                      )
                                    }
                                  />
                                </GrammarlyEditorPlugin>
                              </TableCell>
                            </TableBody>
                          </>
                        );
                      })}
                  </Table>
                </TableContainer>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    textAlign: "start",
                    marginTop: "5px",
                  }}
                >
                  <div style={{ width: "25%", marginLeft: 8 }}>
                    *Risk Description:
                  </div>
                  <div style={{ width: "25%", marginLeft: 8, textAlign: "left" }}>
                    <span style={{ fontSize: "20px", color: "green" }}>
                      &#x25CF;
                    </span>
                    Low Risk Group
                  </div>
                  <div style={{ width: "25%", marginLeft: 8, textAlign: "left" }}>
                    <span style={{ fontSize: "20px", color: "#edbe2f" }}>
                      &#x25CF;
                    </span>
                    Borderline Group
                  </div>
                  <div style={{ width: "25%", marginLeft: 8, textAlign: "left" }}>
                    <span style={{ fontSize: "20px", color: "red" }}>&#x25CF;</span>
                    High Risk Group
                  </div>
                </div>
                <div
                  style={{
                    width: "95%",
                    display: "flex",
                    alignItems: "center",
                    padding: 0,
                    margin: 0,
                    justifyContent: "space-around",
                    marginTop: "20px",
                  }}
                >
                  {niptdoctorList &&
                    niptdoctorList?.length > 0 &&
                    niptdoctorList?.map((list: any, index: number) => {
                      const doctorLabel = String(list?.parameter_value || "").toLowerCase();
                      const isDrAnkurSignature = doctorLabel.includes("ankur") && doctorLabel.includes("jindal");
                      const hasMD115A = niptReport[0]?.packages?.some((pkg: any) => String(pkg?.code || "").trim().toUpperCase() === "MD115A");

                      if (isDrAnkurSignature && !hasMD115A) {
                        return null;
                      }

                      return (
                        <>
                          <img
                            alt="description of image"
                            style={{
                              width: "100px",
                              height: "60px",
                              marginLeft: "60px",
                            }}
                            src={list?.parameter_url}
                          />
                        </>
                      );
                    })}
                </div>
                <div
                  style={{
                    width: "98%",
                    display: "flex",
                    padding: 0,
                    margin: 0,
                    justifyContent: "space-around",
                    marginLeft: "12px",
                  }}
                >
                  {niptdoctorList &&
                    niptdoctorList?.length > 0 &&
                    niptdoctorList?.map((list: any, index: number) => {
                      const doctorLabel = String(list?.parameter_value || "").toLowerCase();
                      const isDrAnkurSignature = doctorLabel.includes("ankur") && doctorLabel.includes("jindal");
                      const hasMD115A = niptReport[0]?.packages?.some((pkg: any) => String(pkg?.code || "").trim().toUpperCase() === "MD115A");

                      if (isDrAnkurSignature && !hasMD115A) {
                        return null;
                      }

                      return (
                        <>
                          <textarea
                            style={{
                              border: "none",
                              resize: "none",
                              textAlign: "center",
                            }}
                            rows={4}
                            cols={130}
                            value={list?.parameter_value}
                            onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}

                          />
                        </>
                      );
                    })}
                </div>
              </div>
            </div>
            {/* page3 */}

            {/* New page: TEST RESULTS with Chromosome Graphs */}
            {niptReport[0]?.packages?.some((pkg: any) => pkg.code === "MD115A") && (
              <>
            <div className="merginLeft graph-page-spacer">
              <div>.</div>
            </div>
            
            <div style={{ padding: "20" }} className="merginLeft">
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  borderRadius: "0px 10px",
                  textAlign: "left",
                  color: "#18556e"
                }}
              >
                TEST RESULTS GRAPHS
                <hr style={{ marginTop: "-3px", marginRight: "9px" }} />
              </div>
              <ChromosomeGraphs
                chromosomTableData={chromosomTableData}
                niptGraphData={niptGraphData}
                tableData={tableData}
                currentBookingId={firstP}
              />
            </div>
              </>
            )}

            {niptReport[0]?.packages?.some((pkg: any) => pkg.code === "MD115A") && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2rem', gap: '2rem' }}>
      <div style={{ flex: 1 }}>
        <h2 style={{ color: '#c47a1e', fontSize: '22px', fontWeight: '600', margin: '0 0 1.5rem' }}>
          Indications for Testing
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
          {[
            'Any Abnormal biochemical marker results (AFP, bHCG, PAPP-A)',
            'All maternal ages; especially women with advanced maternal age (>30 years)',
            'Couple with history of infertility or pregnancy loss (miscarriages or stillbirths)',
            'Any Abnormalities found in NT scan, Ultrasound scan, Nasal bone absent',
          ].map((text, i) => (
            <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
              <span style={{ color: '#c47a1e', fontSize: '16px', marginTop: '2px' }}>■</span>
              <p style={{ margin: 0, fontSize: '14px', color: '#222', lineHeight: '1.5' }}>{text}</p>
            </div>
          ))}
        </div>
        <p style={{ margin: '1.5rem 0 0', fontSize: '13px', color: '#444', lineHeight: '1.6' }}>
          The estimated rate of all clinically significant cytogenetic abnormalities rises from about{' '}
          <span style={{ color: '#c47a1e' }}>1/500</span> at the youngest maternal ages to about{' '}
          <span style={{ color: '#c47a1e' }}>1/270</span> at age 30,{' '}
          <span style={{ color: '#c47a1e' }}>1/80</span> at age 35,{' '}
          <span style={{ color: '#c47a1e' }}>1/60</span> at age 40, and{' '}
          <span style={{ color: '#c47a1e' }}>1/20</span> at age 45
        </p>
      </div>
      <div style={{ flexShrink: 0 }}>
        <img src={pregnantImg} alt="Pregnant woman" style={{ width: '220px' }} />
      </div>
    </div>
            )}

            {/* New page: METHODOLOGY */}
            <div className="merginLeft methodology-page-spacer">
              <div>.</div>
            </div>
            <div style={{ padding: "20", }} className="merginLeft">
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  borderRadius: "0px 10px",
                  textAlign: "left",
                  color: "#18556e"
                }}
              >
                METHODOLOGY
                <hr style={{ marginTop: "-3px", marginRight: "9px" }} />
              </div>
              {niptMethology.map((list: any, index: number) => {
                return (
                  <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "14px",marginTop:"-15px" }}>
                    <GrammarlyEditorPlugin>
                      <textarea
                        style={{ border: "none", resize: "none" }}
                        rows={10}
                        cols={140}
                        value={list?.parameter_value}
                        onChange={(e) => updateMethology(list?.id, e.target.value, index, "free_text", list)}
                      />
                    </GrammarlyEditorPlugin>
                  </div>
                );
              })}
            </div>

            <div style={{ width: "100%", textAlign: "left" }} className="merginLeft">
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  borderRadius: "0px 10px",
                  textAlign: "left",
                  color: "#18556e"
                }}
              >
                TEST LIMITATIONS
                <hr style={{ marginTop: "-5px", marginRight: "9px" }} />
              </div>
              <div style={{ marginLeft: "4px" }}>
                <p>
                  1. The results of this test are for reference only, not for the
                  final diagnosis. Cell-free fetal DNA does not replace the accuracy
                  and precision of prenatal diagnosis with Amniocentesis or
                  Chorionic Villus Sampling (CVS).
                </p>
                <p>
                  2. If the test result is at high risk, genetic counseling and
                  invasive prenatal diagnosis are needed.{" "}
                </p>
                <p>
                  3. If the test result is at low risk, the fetus has a low risk of
                  developing the target disease of this screening, hence unaffected
                  pregnancy.However, the possibility of other abnormalities cannot
                  be excluded, and systematic ultrasound examinations and other
                  prenatal examinations should be conducted.{" "}
                </p>
                <p>
                  4. The accuracy and quality of the test may be affected by low
                  fetal fraction &lt;3.5%, maternal or fetal mosaicism, or other causes
                  (micro-deletions, chromosome re-arrangements, translocations,
                  inversions, unbalanced translocations, uniparental disomy). The
                  possibility of false positive or false negative cannot be ruled
                  out.{" "}
                </p>
                <p>
                  5. The accuracy and quality of the test may be also be affected by
                  high data noise due to improper blood sample collection, handling,
                  storage, or transportation.{" "}
                </p>
                <p>
                  6. This test is not applicable for cases with gestational age &lt;10+0
                  weeks, received allogeneic blood transfusion, A family history of
                  genetic diseases or a high risk of genetic diseases in the fetus,
                  transplantation and allogeneic cell therapy within 1 year or a
                  pregnancy with malignant tumor.
                </p>
                <p>
                  7. The patient must provide complete, accurate and detailed
                  personal information. Redcliffe labs shall not be responsible for
                  the interruption of testing services and inaccurate results caused
                  by inaccurate information or other misleading factors provided by
                  the patient.{" "}
                </p>
                <p>
                  8. The test results in this report are only responsible for the
                  samples submitted for inspection.
                </p>
              </div>
            </div>
            <div style={{ width: "100%", textAlign: "left" }} className="merginLeft">
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  borderRadius: "0px 10px",
                  textAlign: "left",
                  color: "#18556e"
                }}
              >
                REFERENCES
                <hr style={{ marginTop: "-3px", marginRight: "9px" }} />
              </div>
              <div style={{ marginLeft: "4px",marginTop:"-10px" }}>
                <p>
                  Jiang, Fetal., Noninvasive Fetal Trisomy (NIFTY) test: an advanced
                  noninvasive prenatal diagnosis methodology for fetal autosomal and
                  sex chromosomal aneuploidies. BMC Med Genomics, 2012. 5: p. 57.
                </p>
                <p>
                  Chiu, R.W., et al., Noninvasive prenatal diagnosis of fetal
                  chromosomal aneuploidy by massively parallel genomic sequencing of
                  DNA in maternal plasma. BMJ. 2011;342:c7401.
                </p>
                <p>
                  Bianchi, D.W., et al., Genome-wide fetal aneuploidy detection by
                  maternal plasma DNA sequencing. Obstetrics & Gynecology, 2012.
                  119(5): p. 890-901.
                </p>
                <p>
                  Chen, S., et al., A method for noninvasive detection of fetal
                  large deletions/duplications by low coverage massively parallel
                  sequencing. Prenatal Diagnosis, 2013. 33(6): p. 584-590.
                </p>
                <p>
                  Chen, M., et al., Validation of fetal DNA fraction estimation and
                  its application in noninvasive prenatal testing for aneuploidy
                  detection in multiple pregnancies. Prenatal Diagnosis, 2019.
                  39(13): p. 1273-1282.
                </p>
                <p>
                  Lo YM. Non-invasive prenatal diagnosis by massively parallel
                  sequencing of maternal plasma DNA. Open Biol. 2012;2(6):120086.
                </p>
              </div>
            </div>

            <div
              style={{
                width: "95%",
                display: "flex",
                alignItems: "center",
                padding: 0,
                margin: 0,
                justifyContent: "space-around",
                marginTop: "20px",
              }}
            >
              {niptdoctorList &&
                niptdoctorList?.length > 0 &&
                niptdoctorList?.map((list: any, index: number) => {
                    const doctorLabel = String(list?.parameter_value || "").toLowerCase();
                    const isDrAnkurSignature = doctorLabel.includes("ankur") && doctorLabel.includes("jindal");
                    const hasMD115A = niptReport[0]?.packages?.some((pkg: any) => String(pkg?.code || "").trim().toUpperCase() === "MD115A");

                    if (isDrAnkurSignature && !hasMD115A) {
                      return null;
                    }

                  return (
                    <>
                      <img
                        alt="description of image"
                        style={{
                          width: "100px",
                          height: "60px",
                          marginLeft: "60px",
                        }}
                        src={list?.parameter_url}
                      />
                    </>
                  );
                })}
            </div>
            <div
              style={{
                width: "98%",
                display: "flex",
                padding: 0,
                margin: 0,
                justifyContent: "space-around",
                marginLeft: "12px",
              }}
            >
              {niptdoctorList &&
                niptdoctorList?.length > 0 &&
                niptdoctorList?.map((list: any, index: number) => {
                    const doctorLabel = String(list?.parameter_value || "").toLowerCase();
                    const isDrAnkurSignature = doctorLabel.includes("ankur") && doctorLabel.includes("jindal");
                    const hasMD115A = niptReport[0]?.packages?.some((pkg: any) => String(pkg?.code || "").trim().toUpperCase() === "MD115A");

                    if (isDrAnkurSignature && !hasMD115A) {
                      return null;
                    }

                  return (
                    <>
                      <textarea
                        style={{
                          border: "none",
                          resize: "none",
                          textAlign: "center",
                        }}
                        rows={4}
                        cols={130}
                        value={list?.parameter_value}
                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}

                      />
                    </>
                  );
                })}
            </div>
            <div className="merginLeft" style={{ fontWeight: "bold", marginTop: "9px" }}>
              <p style={{ color: "white", backgroundColor: "#e30b2c", textAlign: "center", marginTop: "26px" }}>*AS PER THE ACCORDNACE WITH "PC & PNDT ACT-1994 & AMENDENTS",SEX OF THE FETUS HAS NEITHER BEEN DETECTED NOR DISCLOSED</p>
            </div>
            <div className="tablecontent3">.</div>
            <div className="tablecontent2">.</div>
            <div className="tablecontent2">.</div>
            <div className="tablecontent2">.</div>
            {/* condions and reporting */}
            <div style={{ padding: "20", }} className="merginLeft">
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  borderRadius: "0px 10px",
                  textAlign: "left",
                  color: "#18556e"
                }}
              >
                Conditions for Reporting
                <hr style={{ marginTop: "3px", marginRight: "9px" }} />
              </div>
            </div>
            <div>
              <div style={{
                width: "100%",
                display: "flex",
                // margin: "10px 0px",
                textAlign: "start",
                padding: "5px",
                marginLeft: "-20px"
              }}>
                <ul>
                  <p>1. It is presumed that specimen belongs to patient named or identified, such verification being carried out at the point of generation of said specimen.</p>
                  <p>2. A test might not be performed due to following reasons:
                    <ol>a. Specimen Quantity not sufficient (Inadequate collection/spillage during transit).</ol>
                    <ol>b. Specimen Quality not acceptable (Hemolysis/clotted/lipemic).</ol>
                    <ol>c. Incorrect sample type.</ol>
                  </p>
                  <p>3. In any of the above case a fresh specimen will be required for testing and reporting.</p>
                  <p>4. Partial representation of report is not allowed. </p>
                  <p>5. The reported tests are for the notification of the referring doctor, only to assist him/her in the diagnosis and management of the patient. </p>
                  <p>6. This report is not valid for Medico Legal Purpose. </p>
                  <p>7. Applicable Jurisdiction will be of "Delhi" for any dispute/claim concerning the test(s) & results of the test(s). </p>
                </ul>
              </div>
            </div>
            {/* footer section starting */}
            <div className="page-footer">
              {/* footer area */}
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    background: "#fff",
                    marginTop: "-20px"
                  }}
                >
                  <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                    <h3>
                      <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${niptReport[0]?.uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={115} />
                    </h3>
                  </div>
                  <div
                    style={{
                      width: "85%",
                      textAlign: "left",
                      padding: 10,
                      marginTop: "-3px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        margin: "10px 0px",
                        marginTop: "9px",
                      }}
                    >
                      <div style={{ width: "33%", marginLeft: 8 }}>
                        <img
                          src={callIcon}
                          alt="logo"
                          style={{ width: "15px", margin: "2px" }}
                        />{" "}
                        <span style={{ color: "red", fontWeight: "bold" }}>931-126-1989</span>
                      </div>
                      <div style={{ width: "47%", marginLeft: -5 }}>
                        <img
                          src={maillIcon}
                          alt="logo"
                          style={{ width: "20px", margin: "2px" }}
                        />
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          &nbsp;genee@redcliffelabs.com
                        </span>
                      </div>
                      <div style={{ width: "33%", marginLeft: 19 }}>
                        <img
                          src={browserIcon}
                          alt="logo"
                          style={{ width: "20px", margin: "2px" }}
                        />
                        <span style={{ color: "red", fontWeight: "bold" }}>www.redcliffelabs.com</span>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        margin: "10px 0px",
                        textAlign: "left",
                        marginBottom: "-15px",
                      }}
                    >
                      <h6 style={{ marginLeft: "16px" }}>
                        {" "}
                        Redcliffe Life Sciences Pvt. Ltd. (Unit of Redcliffe Life Sciences
                        inc,USA) H-31,Sector-63,Noida, Uttar Pradesh, 201301
                      </h6>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        margin: "10px 0px",
                        marginLeft: "16px",
                        textAlign: "left",
                      }}
                    >
                      <p style={{ fontSize: "13px", marginTop: "3px" }}>
                        {" "}
                        All Lab are subjected to clinical interpretations by
                        qualified medical professional and this report is not
                        subject to use for any medico-legal purpose.
                      </p>
                    </div>
                    <hr
                      style={{
                        width: "100%",
                        height: "8px",
                        marginTop: "10px",
                      }}
                      className="box"
                    />
                  </div>
                </div>
                {/* second page  */}
              </div>
              {/* footer area closed */}
            </div>
            {/* footer section end */}
             {
                                                                                               uuid && (
                                                                                                   <div className="hide-section-rating">
                                                                                                       <NpsRating bookingId={firstP} uuid={uuid} />
                                                                                                   </div>
                                                                                               )
                                                                                           }
          </div>
        )}
      </div>
    </Grammarly >

  );
};

const mapStateToProps = (state: any) => ({
  reportListParameter: state.LimsAdminReducer.reportListParameter,
  loading: state.LimsAdminReducer.loading,
  niptGraphData: state.LimsAdminReducer.niptGraphData
});

export default connect(mapStateToProps, {
  getReportTemplateParameter,
  createNewReport,
  getUpdatedCustomerReportData,
  updateReport,
  resetBookingData,
  updateNiptDob,
  createNiptDob,
  getNiptGraphData
})(NIPTReport);